<ng-container *ngIf="tokenIsId; then errorContent else content"></ng-container>

<ng-template #errorContent >
  <app-erro></app-erro>
</ng-template>


<ng-template #content >
  <div *ngIf="dadosConsulta && !dadosConsulta?.veiculoEncontrado"
  class="resultado-consulta-container  p-1 mt-5 px-sm-2 px-md-3 px-xl-5">
  <app-card-consulta titulo="DADOS NÃO ENCONTRADOS"
    msg="NÃO ENCONTRAMOS OS DADOS DE SUA CONSULTA, VERIFIQUE SE ESTÃO CORRETOS E EM CASO DE DÚVIDAS ENTRE EM CONTATO COM O NOSSO SUPORTE">
  </app-card-consulta>
</div>

<div class="d-flex d-print-none justify-content-between px-2 p-1 mb-3 bg-white border-bottom border-gray-200"
  *ngIf="exibirHeader && dadosConsulta?.veiculoEncontrado">
  <div *ngIf="dadosConsulta" class="row resultado-consulta-container px-1 px-sm-2 px-md-3 px-xl-5">

    <div class="col-6 col-sm p-1" *ngIf="exibirBtn.novaConsulta">
      <button (click)="novaConsulta()" class="btn btn-theme btn-sm btn-icon w-100">
        <i class="mdi mdi-plus"></i>
        <span>Nova Consulta</span>
      </button>
    </div>

    <div class="col p-1" *ngIf="exibirBtn.novoLaudo">
      <button (click)="redirectNovoLaudo()" class="btn btn-theme btn-sm btn-icon w-100">
        <i class="mdi mdi-plus"></i>
        <span>Novo laudo</span>
      </button>
    </div>

    <div *ngIf="!dadosConsulta.finalizada && !dadosConsulta.decisaoCerta && exibirBtn.editarConsulta"
      class="col-6 col-sm p-1">
      <span data-toggle="tooltip" data-placement="bottom" title="Editar">
        <button (click)="btnEditarConsulta()" class="btn btn-theme btn-sm btn-icon w-100">
          <i class="mdi mdi-pencil"></i>
          <span>Editar</span>
        </button></span>
    </div>

    <div class="col-6 col-sm p-1" *ngIf="exibirBtn.fotos">
      <span data-toggle="tooltip" data-placement="bottom" title="Fotos">
        <button (click)="btnFotos()" class="btn btn-theme btn-sm btn-icon w-100">
          <i class="mdi mdi-camera"></i>
          <span>Fotos</span>
        </button></span>
    </div>

    <div class="col p-1" *ngIf="exibirBtn.imprimirJS">
      <button (click)="impressaoJS()" class="btn btn-theme btn-sm btn-icon w-100 newBtn">
        <i class="mdi mdi-printer"></i>
        <span>Impressão rápida</span>
      </button>
      <!-- <p class="aviso">Nova impressão de PDF</p> -->
    </div>

    <div class="col p-1" *ngIf="exibirBtn.imprimirJS">
      <button rel="noopener noreferrer" target="_blank" (click)="printPdf()" download=""
      class="btn btn-theme btn-sm btn-icon w-100">
      <i class="mdi mdi-printer"></i>
      <span>Impressão</span>
    </button>
    </div>



    <div class="col p-1" *ngIf="!dadosConsulta?.decisaoCerta && exibirBtn.compacto">
      <button (click)="toggleCompacta()" class="btn btn-sm btn-theme btn-icon w-100">
        <i class="mdi" [ngClass]="{'mdi-arrow-expand-all': compacta, 'mdi-arrow-collapse-all': !compacta}"></i>
        <span *ngIf="!compacta">Modo compacto</span>
        <span *ngIf="compacta">Modo expandido</span>
      </button>
    </div>

  </div>
</div>

<section *ngIf="dadosConsulta?.veiculoEncontrado"
  class="resultado-consulta-container p-1 pt-0 pb-5 px-sm-2 px-md-3 px-xl-5">
  <div class="bg-deep-blue mb-3 mb-lg-5" *ngIf="exibirHeader && exibirHeader === true">
    <div class="d-flex justify-content-between align-items-center cabecalho">
      <div [ngClass]="{
        'cabecalho-placa' : dadosConsulta.placaEntrada || dadosConsulta.placaPesquisa,
        'cabecalho-placa-sem' : !dadosConsulta.placaEntrada || !dadosConsulta.placaPesquisa,
        'cabecalho-placa-mercosul' : placaMercosul && dadosConsulta?.placaEntrada
      }">
        <div *ngIf="dadosConsulta.placaEntrada || dadosConsulta.placaPesquisa" class="cabecalho-uf-Municipio">
          {{ emplacamento || '' }}</div>
        <div *ngIf="dadosConsulta.placaEntrada || dadosConsulta.placaPesquisa ">
          {{dadosConsulta?.placaEntrada || dadosConsulta?.placaPesquisa | appPlaca }}</div>
      </div>
      <img src="assets/images/brand_white_color.png" class="cabecalho-logo" alt="Union Solutions" loading="lazy">
      <div class="cabecalho-qrcode d-none d-md-block" id="qrcodeDecisaoCerta">
        <qrcode [qrdata]="qrcodeUrl" [width]="76"></qrcode>
      </div>
      <div class="cabecalho-qrcode d-md-none" id="qrcodeDecisaoCerta">
        <qrcode [qrdata]="qrcodeUrl" [width]="56"></qrcode>
      </div>
    </div>
  </div>

  <section *ngIf="dadosConsulta.possuiConsultaVeicular == true">

    <app-resumo-decisao-certa [(consulta)]='dadosConsulta'></app-resumo-decisao-certa>

    <div *ngIf="dadosConsulta" class="container-consultas">

      <ng-container *ngFor="let c of dadosConsulta.consultas; let i = index">
        <!-- SOMENTE QUANDO FOR DECISÃO CERTA -->
        <ng-container *ngIf="dadosConsulta.decisaoCerta">
          <app-consulta-dados-nacionais class="print-c" *ngIf="c.tipoConsulta=='BIN_RF' && exibirBinfed == false" [consulta]='c.consulta'
            (update)="atualizarConsulta(i, $event)" [titulo]="'Dados Nacionais'" [idConsulta]="c.id"
            [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-dados-nacionais>
        </ng-container>

        <app-consulta-detransc class="print-c" *ngIf="c.tipoConsulta=='DETRANSC'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" titulo="DETRANSC" [idConsulta]="c.id" [tipoConsulta]="c.tipoConsulta"
          [codigoControle]="c.codigoControle" [token]="token"></app-consulta-detransc>

        <app-consulta-dados-estaduais class="print-c" *ngIf="c.tipoConsulta=='BIN_ESTADUAL' || c.tipoConsulta=='BIN_ESTADUAL_UNION'"
          [consulta]='c.consulta' (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-dados-estaduais>

        <app-consulta-bateu-pr class="print-c" *ngIf="c.tipoConsulta=='BATEU'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-bateu-pr>

        <app-consulta-detran-pr class="print-c" *ngIf="c.tipoConsulta=='DETRAN_PR'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-detran-pr>

        <app-consulta-dados-renajud class="print-c" *ngIf="c.tipoConsulta=='BIN_RENAJUD'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-dados-renajud>

        <app-consulta-agregados class="print-c" *ngIf="c.tipoConsulta=='AGREGADOS'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-agregados>

        <app-consulta-indicio-sinistro class="print-c" *ngIf="c.tipoConsulta=='INDICIO_SINISTRO' || c.tipoConsulta=='INDICIO_SINISTRO2'"
          [consulta]='c.consulta' (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-indicio-sinistro>

        <ng-container *ngIf="c.tipoConsulta=='AVISO_CSV'">
            <dados-bloco-senatran class="print-c"></dados-bloco-senatran>
        </ng-container>

        <app-consulta-parecer-tecnico class="print-c" *ngIf="c.tipoConsulta=='PARECER_TECNICO'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-parecer-tecnico>

        <app-consulta-pt class="print-c" *ngIf="c.tipoConsulta=='PT'" [consulta]='c.consulta' (update)="atualizarConsulta(i, $event)"
          [titulo]="c.nomeConsulta" [idConsulta]="c.id" [tipoConsulta]="c.tipoConsulta"
          [codigoControle]="c.codigoControle" [token]="token"></app-consulta-pt>

        <app-consulta-decodificador-chassi
          class="print-c" *ngIf="c.tipoConsulta=='DECODIFICADOR' || c.tipoConsulta=='DECODIFICADOR_ESPECIAL'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-decodificador-chassi>

        <app-consulta-historico-venda class="print-c" *ngIf="c.tipoConsulta=='HISTORICO_VENDA'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-historico-venda>

        <app-consulta-duplicidade-chassi-motor class="print-c" *ngIf="c.tipoConsulta=='MOTOR'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-duplicidade-chassi-motor>

        <app-consulta-gravame class="print-c" *ngIf="c.tipoConsulta=='GRAVAME' || c.tipoConsulta=='GRAVAME_SIMPLES'"
          [consulta]='c.consulta' (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-gravame>

        <app-consulta-recall class="print-c" *ngIf="c.tipoConsulta=='RECALL'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-recall>

        <app-consulta-multa-renainf class="print-c" *ngIf="c.tipoConsulta=='RENAINF'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-multa-renainf>

        <app-consulta-renavam class="print-c" *ngIf="c.tipoConsulta=='RENAVAM'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-renavam>

        <app-consulta-roubo-furto class="print-c" *ngIf="c.tipoConsulta=='BIN_RF'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-roubo-furto>

        <app-consulta-leilao class="print-c" *ngIf="c.tipoConsulta=='LEILAO' || c.tipoConsulta=='LEILAO_3'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-leilao>

        <app-consulta-leilao-complementar class="print-c" *ngIf="c.tipoConsulta=='LEILAO_2'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-leilao-complementar>

        <app-consulta-precificador class="print-c" *ngIf="c.tipoConsulta=='PRECIFICADOR'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-precificador>

        <app-consulta-preco-molicar class="print-c" *ngIf="c.tipoConsulta=='PRECO_MERCADO_MOLICAR'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-preco-molicar>

        <app-consulta-desvalorizacao-media class="print-c" *ngIf="c.tipoConsulta=='DESVALORIZACAO_FIPE'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-desvalorizacao-media>

        <app-consulta-historico-proprietario class="print-c" *ngIf="c.tipoConsulta=='PROPRIETARIOS'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-historico-proprietario>

        <app-consulta-historico-proprietario-simplificado class="print-c" *ngIf="c.tipoConsulta=='PROPRIETARIOS_UNION'"
          [consulta]='c.consulta' (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token">
        </app-consulta-historico-proprietario-simplificado>

        <app-consulta-dados-nacionais
          class="print-c" *ngIf="c.tipoConsulta=='BIN_FEDERAL_UNION' || c.tipoConsulta=='BIN_FEDERAL'  || c.tipoConsulta=='BIN_FEDERAL_RF'"
          [consulta]='c.consulta' (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-dados-nacionais>

        <ng-container *ngIf="!dadosConsulta.decisaoCerta">
          <app-consulta-roubo-furto class="print-c" *ngIf="c.tipoConsulta=='BIN_FEDERAL_RF' " [consulta]='c.consulta'
            (update)="atualizarConsulta(i, $event)" [titulo]="'Histórico de Roubo e Furto'" [idConsulta]="c.id"
            [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-roubo-furto>
        </ng-container>

        <app-consulta-crlv class="print-c" *ngIf="c.tipoConsulta=='CRLV'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-crlv>

        <app-consulta-crlv-e class="print-c" *ngIf="c.tipoConsulta=='CRLV_E'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id" [erroUf]="c?.erroUf"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-crlv-e>

        <app-consulta-cnh class="print-c" *ngIf="c.tipoConsulta=='CNH'" [consulta]='c.consulta' (update)="atualizarConsulta(i, $event)"
          [titulo]="c.nomeConsulta" [idConsulta]="c.id" [tipoConsulta]="c.tipoConsulta"
          [codigoControle]="c.codigoControle" [token]="token"></app-consulta-cnh>

        <app-consulta-dados-historico class="print-c" *ngIf="c.tipoConsulta=='HISTORICO'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-dados-historico>

        <app-consulta-localiza-placa class="print-c" *ngIf="c.tipoConsulta=='LOCALIZA_PLACA'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-localiza-placa>

        <app-consulta-localizador-veiculo class="print-c" *ngIf="c.tipoConsulta=='LOCALIZA_VEICULO'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-localizador-veiculo>

        <app-consulta-cotacao-seguro class="print-c" *ngIf="c.tipoConsulta=='COTACAO_SEGURO'" [consulta]='c.consulta'
          (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-cotacao-seguro>

        <app-consulta-proprietario-licenciamento class="print-c" *ngIf="c.tipoConsulta=='PROPRIETARIO_LICENCIAMENTO'"
          [consulta]='c.consulta' (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-proprietario-licenciamento>

        <app-consulta-precificador-decisao-certa class="print-c" *ngIf="c.tipoConsulta=='PRECIFICADOR_DECISAO_CERTA'"
          [consulta]='c.consulta' (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-precificador-decisao-certa>

        <app-consulta-csv class="print-c" *ngIf="c.tipoConsulta=='CSV'"
          [consulta]='c.consulta' (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-csv>

        <app-consulta-historico-rf-pro class="print-c" *ngIf="c.tipoConsulta=='HISTORICORFPRO'"
          [consulta]='c.consulta' (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-historico-rf-pro>

        <app-consulta-experimental class="print-c" *ngIf="c.tipoConsulta=='EXPERIMENTAL'"
          [consulta]='c.consulta' (update)="atualizarConsulta(i, $event)" [titulo]="c.nomeConsulta" [idConsulta]="c.id"
          [tipoConsulta]="c.tipoConsulta" [codigoControle]="c.codigoControle" [token]="token"></app-consulta-experimental>

      </ng-container>

    </div>

  </section>

  <ng-container *ngIf="dadosConsulta.possuiConsultaCredito == true">
    <app-consulta-resultado-ciac [dadosConsulta]='dadosConsulta'></app-consulta-resultado-ciac>
  </ng-container>

  <app-card-consulta *ngIf="dadosConsulta.fotosConsulta && dadosConsulta.fotosConsulta.length" titulo="Fotos">
    <div class="row p-1">
      <div *ngFor="let f of dadosConsulta.fotosConsulta" class="col-12 col-sm-6 col-md-4 col-lg-3 col-print-3 p-1">
        <a class="btn btn-primary p-0 bg-white w-100" [href]="f.url" rel="noopener noreferrer" target="_blank">
          <img class="img-fluid rounded" (error)="imgError($event, f)" title="{{f.nome}}" src="{{ f.src || f.url  }}">
          <div class="rounded bg-light text-primary p-1 text-overflow-ellipsis">{{f.nome}}</div>
        </a>
      </div>
    </div>

    <div class="mt-2" *ngIf="dadosConsulta?.observacoes">
      <div class="px-2 fw-500 border-bottom border-primary text-primary">Observações:</div>
      <div class="rounded bg-light p-3">{{dadosConsulta?.observacoes}}</div>
    </div>
  </app-card-consulta>

  <app-footer-consulta></app-footer-consulta>


  <app-modal-fotos-consulta></app-modal-fotos-consulta>
  <app-modal-editar-consulta [tokenConsulta]="token" [cnhEntrada]="dadosConsulta.cnhEntrada"
    [documentoEntrada]="dadosConsulta.documentoEntrada" [crlvEntrada]="dadosConsulta.crlvEntrada"
    [placaEntrada]="dadosConsulta.placaEntrada" [motorEntrada]="dadosConsulta.motorEntrada"
    [chassiEntrada]="dadosConsulta.entrada" [consultasExecutadas]="dadosConsulta.consultas"></app-modal-editar-consulta>

</section>

</ng-template>